// import Swiper, { Keyboard, Navigation } from 'swiper'

// # main function
sliders()
function sliders() {
  addClassSwiper()

  const casesSliders = document.querySelectorAll('.cases__slider')
  if (casesSliders.length > 0) {
    casesSliders.forEach(slider => {
      const btnRight = slider.querySelector('.cases__btn-slider_right')
      const btnLeft = slider.querySelector('.cases__btn-slider_left')

      new Swiper(slider, {
        direction: 'horizontal',
        effect: 'slide',
        loop: false,
        speed: 1000,
        spaceBetween: 24,
        slidesPerView: 'auto',
        watchOverflow: true,

        // modules: [Keyboard, Navigation],

        navigation: {
          nextEl: btnRight,
          prevEl: btnLeft,
        },

        keyboard: {
          enabled: true,
        },

        breakpoints: {
          1100.98: {
            slidesPerView: 2,
          },
        },
      })
    })
  }

  if (document.querySelector('.reviews__slider')) {
    new Swiper(document.querySelector('.reviews__slider'), {
      direction: 'horizontal',
      effect: 'slide',
      loop: false,
      speed: 1000,
      spaceBetween: 24,
      slidesPerView: 'auto',
      watchOverflow: true,

      // modules: [Keyboard, Navigation],

      navigation: {
        nextEl: '.reviews__btn-slider_right',
        prevEl: '.reviews__btn-slider_left',
      },

      keyboard: {
        enabled: true,
      },
    })
  }
}

//# addClassSwiper
function addClassSwiper() {
  const $sliders = document.querySelectorAll('[class*="__swiper"]')

  $sliders.forEach(slider => {
    slider = slider.parentElement
    const wrapper = slider.children[0]
    const slides = Array.from(wrapper.children)

    slider.classList.add('swiper')
    wrapper.classList.add('swiper-wrapper')
    slides.forEach(addClassSlide)
  })
}

//# addClassSlide
function addClassSlide(slide) {
  slide.classList.add('swiper-slide')
}
